import { Button, ButtonProps } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

export interface NavButtonProps extends React.PropsWithChildren<{}>, ButtonProps {
  to: string;
  exact?: boolean;
}

export function NavButton(props: NavButtonProps) {
  const location = useLocation();

  const isActive = props.exact
    ? location.pathname === props.to
    : location.pathname.startsWith(props.to);

  return (
    <Button
      component={Link}
      color={isActive ? 'primary' : 'inherit'}
      sx={{
        ...(isActive && {
          backgroundColor: (theme) => theme.palette.action.hover,
          color: (theme) =>
            theme.palette.mode == 'dark' ? theme.palette.primary.main : theme.palette.primary.dark,
        }),
      }}
      {...props}
    >
      {props.children}
    </Button>
  );
}
